export const deduplicate = (array: any[]) => {
    return Array.from(new Set(array))
}


export const merge = (obj1: any = {}, obj2: any = {}) => {

    const commonFields = Object.keys(obj1).reduce((res: any, key) => {
        if (Array.isArray(res[key]) && !!obj2[key]) {
            return {
                ...res,
                [key]: deduplicate([...res[key], ...obj2[key]]),
            }
        }
        return res;
    }, obj1)

    const extraFields = Object.keys(obj2).reduce((res: any, key) => {
        if (!obj1[key] || !Array.isArray(obj1[key])) {
            return {
                ...res,
                [key]: obj2[key],
            }
        }
        return res;
    }, {})

    const projectStatus = obj2?.projectStatus?.length ? obj2.projectStatus : obj1.projectStatus;
    const bookStatus = obj2?.bookStatus?.length ? obj2.bookStatus : obj1.bookStatus;
    const useCalendar = obj1?.hasOwnProperty('useCalendar') && !!obj1?.useCalendar ? obj1?.useCalendar : obj2?.useCalendar;
    const isPaid = obj1?.hasOwnProperty('isPaid') && !!obj1?.isPaid ? obj1?.isPaid : obj2?.isPaid;

    return {
        ...commonFields,
        ...extraFields,
        ...(projectStatus ? { projectStatus } : {}),
        ...(bookStatus ? { bookStatus } : {}),
        ...(useCalendar ? { useCalendar } : {}),
        ...(isPaid ? { isPaid } : {}),
        tags: [],
        requiredTags: [],
        exceptedTags: [],
    }
}export const deduplicate = (array: any[]) => {
    return Array.from(new Set(array))
}


export const merge = (obj1: any = {}, obj2: any = {}) => {

    const commonFields = Object.keys(obj1).reduce((res: any, key) => {
        if (Array.isArray(res[key]) && !!obj2[key]) {
            return {
                ...res,
                [key]: deduplicate([...res[key], ...obj2[key]]),
            }
        }
        return res;
    }, obj1)

    const extraFields = Object.keys(obj2).reduce((res: any, key) => {
        if (!obj1[key] || !Array.isArray(obj1[key])) {
            return {
                ...res,
                [key]: obj2[key],
            }
        }
        return res;
    }, {})

    const projectStatus = obj2?.projectStatus?.length ? obj2.projectStatus : obj1.projectStatus;
    const bookStatus = obj2?.bookStatus?.length ? obj2.bookStatus : obj1.bookStatus;
    const useCalendar = obj1?.hasOwnProperty('useCalendar') && !!obj1?.useCalendar ? obj1?.useCalendar : obj2?.useCalendar;
    const isPaid = obj1?.hasOwnProperty('isPaid') && !!obj1?.isPaid ? obj1?.isPaid : obj2?.isPaid;

    return {
        ...commonFields,
        ...extraFields,
        ...(projectStatus ? { projectStatus } : {}),
        ...(bookStatus ? { bookStatus } : {}),
        ...(useCalendar ? { useCalendar } : {}),
        ...(isPaid ? { isPaid } : {}),
        tags: [],
        requiredTags: [],
        exceptedTags: [],
    }
}